var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoFlechaElevva(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.871,
    height: 49.738,
    viewBox: "0 0 28.871 49.738",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1541.871 -277.716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1058.087,752.1l-14.407-18.713-14.4,18.713-.029.042h8.006l6.564,19.593,6.454-19.593h7.848Z",
    transform: "translate(512.625 -455.672)",
    fill: "#808ff3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.506,1252.232h-9.178l1.448,3.885h6.281Z",
    transform: "translate(412.27 -928.663)",
    fill: "#10232b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFlechaElevva);
export default __webpack_public_path__ + "static/media/ICO-FLECHA-ELEVVA.f1548c4412c6f5a8754231d4c0df9681.svg";
export { ForwardRef as ReactComponent };